import { Badge } from "@/components/ui/badge";
import { useStats, StatsToolbar, KpiRow, RankingList, StatsTable, SiteLink, fmtAt } from "@/components/StatsReport";

const KIND = { release_zip: "Media kit ZIP", release_pdf: "Comunicato PDF", release_asset: "Foto/Video HD", media: "Libreria Media", release: "Comunicato" };

export function PressStatsTab() {
  const { range, setRange, data, loading, updatedAt, reload } = useStats("/admin/stats/press");
  const t = data?.totals || {};
  return (
    <div className="space-y-4" data-testid="press-stats-tab">
      <StatsToolbar range={range} setRange={setRange} updatedAt={updatedAt} loading={loading} onReload={reload} testId="press-stats" />
      <KpiRow testId="press-stats-kpi" items={[
        { key: "downloads", label: "Download", value: t.downloads },
        { key: "views", label: "Comunicati aperti", value: t.views },
        { key: "outlets", label: "Testate attive", value: t.outlets },
        { key: "profiles", label: "Giornalisti", value: t.profiles },
      ]} />
      <StatsTable title="Registro download in tempo reale" testId="press-stats-log" rowTestId="press-stats-log-row"
        rows={(data?.events || []).filter((e) => e.type === "download")}
        columns={[
          { key: "at", label: "Data / Ora", render: (e) => <span className="whitespace-nowrap text-xs">{fmtAt(e.at)}</span> },
          { key: "outlet", label: "Testata", render: (e) => <span className="font-medium">{e.actor?.outlet || "—"}</span> },
          { key: "site", label: "Sito / Dominio", render: (e) => <SiteLink url={e.actor?.website} /> },
          { key: "profile", label: "Profilo", render: (e) => <div className="text-xs"><div className="font-medium text-foreground">{e.actor?.name || "—"}</div><div className="text-muted-foreground">{e.actor?.email}</div></div> },
          { key: "item", label: "File / Comunicato", render: (e) => <div className="text-xs"><Badge variant="secondary" className="mr-1.5 rounded-full text-[10px]">{KIND[e.item?.kind] || e.item?.kind || "file"}</Badge>{e.item?.title || e.item?.filename || "—"}</div> },
        ]} />
      <div className="grid gap-4 lg:grid-cols-2">
        <RankingList title="Comunicati e media kit più scaricati" rows={data?.top_items} testId="press-stats-top-items"
          renderExtra={(r) => r.extra?.kind && <Badge variant="outline" className="rounded-full text-[10px]">{KIND[r.extra.kind] || r.extra.kind}</Badge>} />
        <RankingList title="Testate più attive" rows={data?.top_outlets} testId="press-stats-top-outlets"
          renderExtra={(r) => <span className="ml-1 inline-flex items-center gap-2 text-xs text-muted-foreground"><SiteLink url={r.extra?.website} /> · ultimo: {fmtAt(r.last_at)}</span>} />
      </div>
    </div>
  );
}
